<template>
  <div class="row" justify="center">
    <v-col md="12">
      <v-breadcrumbs :items="items">
        <template v-slot:divider>
          <v-icon>mdi-forward</v-icon>
        </template>
      </v-breadcrumbs>
    </v-col>
    <v-col
      ><v-sheet color="white" elevation="1" class="pa-5">
        <h2>Potential Driving Instructor Trainig Pack Upload/Download</h2>
        <v-divider></v-divider>
        <DocDownloader :data-array="passData" upload-type="training" />
        <!-- //<DocDownloader dataArray="hello" /> -->
      </v-sheet>
    </v-col>
  </div>
</template>

<script>
import DocDownloader from "@/components/Admin/DocDownloader.vue";
import { mapActions, mapGetters } from "vuex";
import { M_OA, LOAD_PDI_TC, GET_PDI_TC } from "@/store/mutation-list";
//import { Footer } from "@/components/Footer.vue";
export default {
  name: "UploadTrainigPack",
  components: { DocDownloader },

  data: () => ({
    items: [
      {
        text: "Admin Dashboard",
        disabled: false,
        href: "/dashboard/adminhome",
      },
      {
        text: "Upload/Download PDI Trainig Pack",
        disabled: true,
        href: "/dashboard/uploadtrainigpack",
      },
    ],
  }),
  computed: {
    ...mapGetters({
      passData: `${M_OA}${GET_PDI_TC}`,
    }),
  },
  methods: {
    ...mapActions({
      loadFileHistory: `${M_OA}${LOAD_PDI_TC}`,
    }),
  },
  created() {
    this.loadFileHistory();
  },
};
</script>

<style></style>
